import { Clock, MapPin, MessageCircle } from "lucide-react";
import { useLanguage } from "@/i18n";
import { waLink } from "@/whatsapp";
import { Reveal, SectionHeader } from "@/components/Reveal";

export const ContactSection = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" className="py-24 sm:py-32 bg-midnight border-t border-hairline/60" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <SectionHeader eyebrow={t.contact.eyebrow} title={t.contact.title} sub={t.contact.sub} />
          <Reveal delay={0.2} className="mt-10 space-y-5">
            <a
              href={waLink(t.wa.msgContact)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-link"
              className="flex items-center gap-4 text-ivory/80 hover:text-gold transition-colors"
            >
              <MessageCircle className="w-5 h-5 text-gold" strokeWidth={1.5} />
              <span className="text-sm sm:text-base tracking-wide">
                WhatsApp — <span className="text-gold font-semibold">{t.wa.number}</span>
              </span>
            </a>
            <div className="flex items-center gap-4 text-ivory/70">
              <Clock className="w-5 h-5 text-gold" strokeWidth={1.5} />
              <span className="text-sm sm:text-base">{t.wa.note}</span>
            </div>
            <div className="flex items-center gap-4 text-ivory/70">
              <MapPin className="w-5 h-5 text-gold" strokeWidth={1.5} />
              <span className="text-sm sm:text-base">{t.contact.zonesLabel}</span>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.25}>
          <div className="bg-obsidian border border-hairline rounded-lg p-10 sm:p-12 text-center hover:border-gold/40 transition-colors duration-500">
            <p className="font-serif text-2xl sm:text-3xl text-ivory leading-snug">{t.footer.tagline}</p>
            <p className="mt-4 text-sm text-slate-400">{t.wa.note}</p>
            <p className="mt-1 font-mono text-lg tracking-[0.15em] text-gold" data-testid="contact-phone-number">
              {t.wa.number}
            </p>
            <a
              href={waLink(t.wa.msgVisit)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-book-cta"
              className="mt-8 group inline-flex items-center gap-3 bg-gold text-obsidian font-bold text-sm tracking-[0.08em] px-8 py-4 rounded-full hover:bg-gold-light transition-colors duration-300"
            >
              <MessageCircle className="w-4 h-4" />
              {t.wa.cta}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
